import { styled as l } from "@mui/material";
import { TriangleDirection as e } from "../constants/variant.js";
import { useMemo as m } from "react";
import { jsx as i } from "react/jsx-runtime";
const p = l("polygon")`
  fill: #febe36;
`, h = (n) => {
  const {
    direction: r = e.Up,
    h: o = 12,
    w: t = 18,
    className: s
  } = n, $ = m(() => ({
    [e.Up]: [`${t / 2},0`, `0,${o}`, `${t},${o}`],
    [e.Right]: ["0,0", `0,${o}`, `${t},${o / 2}`],
    [e.Down]: ["0,0", `${t},0`, `${t / 2},${o}`],
    [e.Left]: [`${t},0`, `${t},${o}`, `0,${o / 2}`]
  }), [o, t]);
  return /* @__PURE__ */ i("svg", {
    className: s,
    width: t,
    height: o,
    children: /* @__PURE__ */ i(p, {
      className: "Custom-Polygon",
      points: $[r].join(" ")
    })
  });
};
export {
  h as default
};
//# sourceMappingURL=Triangle.js.map
